import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter
} from '../components/ui/dialog';
import { Button } from '../components/ui/button';
import GroupsForm from '../forms/groups-form';

type DialogProps = {
  id?: number
  isOpen: boolean
  closeDialog: () => void
  updateList?: () => void
}

export function DialogCreateGroups({ isOpen = false, closeDialog, updateList }: DialogProps) {


  return (
    <Dialog open={isOpen}>
      <DialogContent className="sm:max-w-4xl">
        <DialogHeader className="border-acelerafit-gray-dark">
          <DialogTitle className="text-acelerafit-green-300">Grupo Muscular</DialogTitle>
          <DialogDescription>Criação</DialogDescription>
        </DialogHeader>
        <GroupsForm
          closeDialog={closeDialog}
          updateList={updateList}
        />
        <DialogFooter className="sm:justify-end w-148">
          <Button
            onClick={() => closeDialog()}
            className="bg-acelerafit-green-300 shadow-2xl hover:bg-acelerafit-green-300 hover:opacity-85 transition-all"
          >
            Fechar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}